import {i18n} from '@/plugins/i18n'

export const providerType = {
    SANBOD: 'SANBOD',
    SHAHIN: 'SHAHIN',
    SAMAN: 'SAMAN',
    SUNYSADERAT: 'SUNYSADERAT',
    SATPAY: 'SATPAY',
    KESHAVARZI: 'KESHAVARZI',
}

export const services = {
    INTERNAL_TRANSFER: 'internal_transfer',
    PAYA_TRANSFER: 'paya_transfer',
    SATNA_TRANSFER: 'satna_transfer',
    CARD_TO_IBAN: 'card_to_iban',
    // CARD_TO_ACCOUNT: 'card_to_account',
    IBAN_TO_ACCOUNT: 'iban_to_account',
    ACCOUNT_TO_IBAN: 'account_to_iban',
    INVOICE: 'invoice',
    // SATNA_REPORT: 'satna_report',
    // PAYA_REPORT: 'paya_report',
    MATCHING_NATIONAL_ID_MOBILE: 'matching_national_id_mobile',
    // POSTAL_CODE_INFORMATION: 'postal_code_information',
    IBAN_INQUIRY: 'iban_inquiry',
    // CARD_OWNER_INFORMATION_INQUIRY: 'card_owner_information_inquiry',
    // ACCOUNT_OWNER_NAME_INQUIRY: 'account_owner_name_inquiry',
    // CARD_INQUIRY: 'card_inquiry',
    MATCHING_CARD_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_card_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_iban_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_INQUIRY: 'matching_iban_national_id_inquiry',
    BALANCE: 'balance',
    UPDATE_SUBSCRIPTION: 'update_subscription',
    VITAL_INFO: 'vital_info',
    STATEMENT: 'statement',
    IPG_GATEWAY_TRANSACTION_REFUND: 'ipg_gateway_transaction_refund',
}

export const sanbodServices = {
    INTERNAL_TRANSFER: 'internal_transfer',
    PAYA_TRANSFER: 'paya_transfer',
    SATNA_TRANSFER: 'satna_transfer',
    CARD_TO_IBAN: 'card_to_iban',
    // CARD_TO_ACCOUNT: 'card_to_account',
    IBAN_TO_ACCOUNT: 'iban_to_account',
    ACCOUNT_TO_IBAN: 'account_to_iban',
    INVOICE: 'invoice',
    // SATNA_REPORT: 'satna_report',
    // PAYA_REPORT: 'paya_report',
    MATCHING_NATIONAL_ID_MOBILE: 'matching_national_id_mobile',
    // POSTAL_CODE_INFORMATION: 'postal_code_information',
    IBAN_INQUIRY: 'iban_inquiry',
    // CARD_OWNER_INFORMATION_INQUIRY: 'card_owner_information_inquiry',
    // ACCOUNT_OWNER_NAME_INQUIRY: 'account_owner_name_inquiry',
    // CARD_INQUIRY: 'card_inquiry',
    MATCHING_CARD_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_card_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_iban_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_INQUIRY: 'matching_iban_national_id_inquiry',
}
export const sunySaderatServices = {
    INVOICE: 'invoice',
}

export const shahinServices = {
    INVOICE: 'invoice',
    BALANCE: 'balance',
}

export const financialServices = {
    INTERNAL_TRANSFER: 'internal_transfer',
    PAYA_TRANSFER: 'paya_transfer',
    SATNA_TRANSFER: 'satna_transfer',
    INVOICE: 'invoice',
    // SATNA_REPORT: 'satna_report',
    // PAYA_REPORT: 'paya_report',
    BALANCE: 'balance',
    STATEMENT: 'statement',
    IPG_GATEWAY_TRANSACTION_REFUND: 'ipg_gateway_transaction_refund',
}

export const authenticationServices = {
    MATCHING_CARD_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_card_national_id_birth_date_inquiry',
    MATCHING_IBAN_NATIONAL_ID_BIRTH_DATE_INQUIRY: 'matching_iban_national_id_birth_date_inquiry',
    MATCHING_NATIONAL_ID_MOBILE: 'matching_national_id_mobile',
    // POSTAL_CODE_INFORMATION: 'postal_code_information',
    MATCHING_IBAN_NATIONAL_ID_INQUIRY: 'matching_iban_national_id_inquiry',
    VITAL_INFO: 'vital_info',
}

export const inquiryServices = {
    IBAN_INQUIRY: 'iban_inquiry',
    // CARD_OWNER_INFORMATION_INQUIRY: 'card_owner_information_inquiry',
    // ACCOUNT_OWNER_NAME_INQUIRY: 'account_owner_name_inquiry',
    // CARD_INQUIRY: 'card_inquiry',
    CARD_TO_IBAN: 'card_to_iban',
    // CARD_TO_ACCOUNT: 'card_to_account',
    IBAN_TO_ACCOUNT: 'iban_to_account',
    ACCOUNT_TO_IBAN: 'account_to_iban',
}

export const applicationServiceStatus = {
    PENDING: 1,
    ACTIVE: 2,
    BLOCKED: 3,
}

export const providerTypeStr = {
    SANBOD: i18n.t('application.providers.sanbod'),
    SHAHIN: i18n.t('application.providers.shahin'),
    SAMAN: i18n.t('application.providers.saman'),
    SUNYSADERAT: i18n.t('application.providers.suny_saderat'),
    SATPAY: i18n.t('application.providers.satpay'),
    KESHAVARZI: i18n.t('application.providers.keshavarzi'),

    get(provider) {
        let str = null;

        Object.keys(providerType).forEach(item => {
            if (providerType[item] === provider) {
                str = providerTypeStr[item];
            }
        });

        return str;
    }
}

export const applicationServiceStatusStr = {
    PENDING: i18n.t('application.service_status.pending'),
    ACTIVE: i18n.t('application.service_status.active'),
    BLOCKED: i18n.t('application.service_status.blocked'),

    get(status) {
        let str = null;

        Object.keys(applicationServiceStatus).forEach(item => {
            if (applicationServiceStatus[item] === status) {
                str = applicationServiceStatusStr[item];
            }
        });

        return str;
    }
}

export const providersHaveService = {
    get(service) {
        let providers = []

        Object.keys(sanbodServices).forEach(item => {
            if (sanbodServices[item] === service) {
                providers.push(providerType.SANBOD)
            }
        });

        Object.keys(shahinServices).forEach(item => {
            if (shahinServices[item] === service) {
                providers.push(providerType.SHAHIN)
            }
        })
        Object.keys(sunySaderatServices).forEach(item => {
            if (sunySaderatServices[item] === service) {
                providers.push(providerType.SUNYSADERAT)
            }
        })

        return providers;
    }
}


export const openBankingRequestsStatus = {
    CREATED: 1,
    SUCCESS: 2,
    FAILED: 3,
}

export const openBankingTransferDetectedType = {
    AUTOMATICALLY: 0,
    BY_ADMIN: 1,
}


export const openBankingTransferDetectedTypeStr = {
    BY_ADMIN: i18n.t('open_banking.detected_by_admin'),
    AUTOMATICALLY: i18n.t('open_banking.detected_automatically'),

    get(status) {
        let str = null;

        Object.keys(openBankingTransferDetectedType).forEach(item => {
            if (openBankingTransferDetectedType[item] === status) {
                str = openBankingTransferDetectedTypeStr[item];
            }
        });

        return str;
    }
}
export const openBankingRequestsStatusStr = {
    CREATED: i18n.t('open_banking.open_banking_request_status.created'),
    SUCCESS: i18n.t('open_banking.open_banking_request_status.success'),
    FAILED: i18n.t('open_banking.open_banking_request_status.failed'),

    get(status) {
        let str = null;

        Object.keys(openBankingRequestsStatus).forEach(item => {
            if (openBankingRequestsStatus[item] === status) {
                str = openBankingRequestsStatusStr[item];
            }
        });

        return str;
    }
}
export const openBankingRequestStatusVariant = (status) => {
    if (status === openBankingRequestsStatus.CREATED) {
        return 'warning';
    }

    if (status === openBankingRequestsStatus.SUCCESS) {
        return 'success';
    }

    if (status === openBankingRequestsStatus.FAILED) {
        return 'danger';
    }

    return 'secondary';
};

export const bankAccessTokenStatus = {
    PENDING: 1,
    ACTIVE: 2,
    REJECT: 3,
}
export const bankAccessTokenStatusStr = {
    PENDING: i18n.t('application.bank_access_token_status.pending'),
    ACTIVE: i18n.t('application.bank_access_token_status.active'),
    REJECT: i18n.t('application.bank_access_token_status.rejected'),

    get(status) {
        let str = null;

        Object.keys(bankAccessTokenStatus).forEach(item => {
            if (bankAccessTokenStatus[item] === status) {
                str = bankAccessTokenStatusStr[item];
            }
        });

        return str;
    }
}

export const applicationWageType = {
    GENERAL: 1,
    DEDICATED: 2,
}

export const changeableWageServices = {
    INTERNAL_TRANSFER: 'internal_transfer',
    PAYA_TRANSFER: 'paya_transfer',
    SATNA_TRANSFER: 'satna_transfer',
    STATEMENT: 'statement',
    IPG_GATEWAY_TRANSACTION_REFUND: 'ipg_gateway_transaction_refund',
}

export const applicationWageTypeStr = {
    GENERAL: i18n.t('label.general'),
    DEDICATED: i18n.t('label.dedicated'),

    get(type) {
        let str = null;

        Object.keys(applicationWageType).forEach(item => {
            if (applicationWageType[item] === type) {
                str = applicationWageTypeStr[item];
            }
        });

        return str;
    }
}

export const openBankingProviders = {
    ShahinKeshavarzi: 'ShahinKeshavarzi',
    ShahinSaderat: 'ShahinSaderat',
    Saman: 'Saman',
    Mellat: 'Mellat',
    FaraboomMelli: 'FaraboomMelli',
    FinnotechAyande: 'FinnotechAyande',
    Sanbod: 'Sanbod',
    SunySaderat: 'SunySaderat',
    Satpay: 'Satpay',
    Keshavarzi: 'Keshavarzi',
}

export const openBankingProvidersStr = {
    ShahinKeshavarzi: i18n.t('application.open_banking_providers.ShahinKeshavarzi'),
    ShahinSaderat: i18n.t('application.open_banking_providers.ShahinSaderat'),
    Saman: i18n.t('application.open_banking_providers.Saman'),
    Mellat: i18n.t('application.open_banking_providers.Mellat'),
    FaraboomMelli: i18n.t('application.open_banking_providers.FaraboomMelli'),
    FinnotechAyande: i18n.t('application.open_banking_providers.FinnotechAyande'),
    Sanbod: i18n.t('application.open_banking_providers.Sanbod'),
    SunySaderat: i18n.t('application.open_banking_providers.SunySaderat'),
    Satpay: i18n.t('application.open_banking_providers.Satpay'),
    Keshavarzi: i18n.t('application.open_banking_providers.Keshavarzi'),

    get(type) {
        let str = null;

        Object.keys(openBankingProviders).forEach(item => {
            if (openBankingProviders[item] === type) {
                str = openBankingProvidersStr[item];
            }
        });

        return str;
    }
}


